import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CVBarman from './Pages/CVBarman/CVBarman';

function App() {
  return (
    <Routes>
      <Route path="/" element={<CVBarman />} />
      {/* Redirection par défaut vers l'accueil si l'URL est inconnue */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;